import BigNumber from 'bignumber.js'
import React, { useCallback, useMemo, useState } from 'react'
import Web3 from 'web3'
import styled from 'styled-components'
import Logo from 'components/Logo'
import { getChecksumAddress } from 'utils/addressHelpers'

const Image = styled(Logo)`
  height: 64px;
  width: auto;
  display: inline-block;
  vertical-align: middle;
  vertical-align: middle;
`

interface IconProps {
    token: any,
}

const Icon : React.FC<IconProps> = ({ token }) => {
    return (
      <Image srcs={[`https://asset.benswap.cash/assets/${getChecksumAddress(token)}/logo.png`,"/images/UNKNOWNSEP20.png"]} alt={`${token} Logo`} />
    )
}

export default Icon
